import { Table } from 'antd';
// import "../Table/Table.css"
import "../../GlobalCss/SPF/Table.css";
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Get_DV_ConsolidatedReport } from '../../redux/TimeCardsRedux/TimeCardsActions';

const columns = [
  {
    title: <span style={{ color: 'white' }}>Client Name</span>,
    dataIndex: 'clientName',
    width: 150,
    
  },
  {
    title: <span style={{ color: 'white' }}>Portal Hours</span>,
    dataIndex: 'portalHrs',
    width: 100,
    render: (text) => {
      const parsedValue = parseFloat(text);
      return parsedValue % 1 === 0 ? parsedValue.toFixed(0) : parsedValue.toFixed(2);
    },
  },
  {
    title: <span style={{ color: 'white' }}>Consolidate Hours</span>,
    dataIndex: 'consolidationHrs',
    width: 100,
  },
  {
    title: <span style={{ color: 'white' }}>Difference</span>,
    dataIndex: 'difference',
    width: 100,
  },

];

const FixedTable = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(Get_DV_ConsolidatedReport());
  }, []);

  const DVConsolidatedReportState = useSelector(state=>state.dvReducer.DV_ConsolidationReport)
const pageSize = 8;
  return (

    <div style={{ width: "100%" }}>

      <Table
        className='fixed-table'
        columns={columns}
        dataSource={DVConsolidatedReportState}
        scroll={{ x: "max-content", y: 300 }}
        pagination={false}
      />
    </div>
  );

}
export default FixedTable;